import { IPostBankAdditionalInstallment } from '../models/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { CommonPostResponse } from '../../../components/models/models'

export class AddBankAdditionalInstallmentsApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/dealerPaymentOperation/addBankAdditionalInstallment',
      requesterInfo,
    })
  }

  public async addBankAdditionalInstallment(request: IPostBankAdditionalInstallment[]): Promise<CommonPostResponse> {
    return await this.postAsync<CommonPostResponse>(request)
  }
}
